<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nq8zUD/tc-custom/9783987449222.jpg?1704425334878" alt="This image is the cover for the book The Serpent's Tooth, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Serpent's Tooth, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Excerpt: "As a child, Letty had promised to be rather pretty, and Mrs. Fenchurch believed that with her own social advantages, she would marry her off ere long; but before arriving at this happy period, she resolved to make the poor relation useful in the house. She should dust china, arrange flowers, pour out tea, help in the garden, and take over the Mothers' Sewing Club. Her own hands were more than full both at home and abroad (indeed, the influence of Mrs. Fenchurch now radiated far and wide), she was secretary here, treasurer and chairwoman there, and was often sorely pressed for time. Oh yes, Letty would have her uses but all the same a girl in the house - a girl, who was always en evidence, to whom one must be a sort of model and sheep dog, would undoubtedly be an intolerable nuisance."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        B. M. Croker
      </h2>
      
      <p class="authorDescription body article">Bithia Mary (or May) Croker (née Sheppard, c. 1848 or 1849[1] – 20 October 1920) was an Irish novelist, most of whose work concerns life and society in British India. Her 1917 novel The Road to Mandalay, set in Burma, was the uncredited basis for a 1926 American silent film, of which only excerpts survive. She was also a notable writer of ghost stories.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?010516d0